import { Menu, MenuItem } from '@mui/material';
import BankingCadsRules from 'components/Banking/Cards';
import { Icon as IconeSimbolo } from 'components/Icon';
import Button from 'components/Form/Button';
import Input from 'components/Form/Input';
import Toggle from 'components/Form/Toggle';
import { CoreContext } from 'context/CoreContext';
import { useContext, useState } from 'react';
import { FormSpacer, Icon, Title } from 'ui/styled';
import {
  ButtonContent,
  ContainerOutlined,
  HeaderActions,
  Link,
  MenuItemDescricao,
  MenuItemTexto,
  MenuItemTitulo,
  TableHeaderSubTitle,
  TableHeaderTitleContainer,
  TableWrapperButtonContainer,
  TableWrapperContainer,
  TableWrapperHeader,
} from './styled';

export default function TableWrapper({
  children,
  title,
  search,
  subTitle,
  buttons,
  noTop,
  background,
  link,
  onLink,
  toggle,
  nospace,
  distribuidor,
  // Filtros proprios da tela, renderizados ao lado do campo de busca.
  filters,
}) {
  const { searchExpression, setSearchExpression } = useContext(CoreContext);
  const [checked, setChecked] = useState(true);
  // Ancora do dropdown: guarda tambem qual botao abriu, porque o cabecalho
  // pode ter mais de um botao com opcoes.
  const [menuAberto, setMenuAberto] = useState(null);
  const handleSearchChange = (event) => setSearchExpression(event.target.value);

  return (
    <TableWrapperContainer background={background}>
      <TableWrapperHeader>
        <TableHeaderTitleContainer>
          {!title ? null : (
            <Title small nomargin>
              {!toggle ? null : (
                <Toggle label={title} checked={checked} onChange={setChecked} />
              )}
              {toggle ? null : title}
              {!subTitle ? null : (
                <TableHeaderSubTitle>
                  {subTitle} {link && <Link onClick={onLink}>{link}</Link>}
                </TableHeaderSubTitle>
              )}
            </Title>
          )}
          <HeaderActions>
            {distribuidor && <BankingCadsRules distribuidor={distribuidor} />}
            {filters}
            {!search ? null : (
              <ContainerOutlined white noTop={noTop}>
                <Input
                  placeholder="Pesquisar"
                  search
                  holder
                  small
                  transparent
                  type="text"
                  endIcon={<Icon icon="search" />}
                  value={searchExpression}
                  onChange={handleSearchChange}
                />
              </ContainerOutlined>
            )}
          </HeaderActions>
        </TableHeaderTitleContainer>
        <TableWrapperButtonContainer>
          {buttons?.map((m, indice) => (
            <ButtonContent key={indice}>
              <Button
                color={m?.color}
                startIcon={m?.icon && <Icon icon={m?.icon} nomargin />}
                endIcon={
                  m?.options?.length ? (
                    <Icon icon="chevron-down" nomargin />
                  ) : null
                }
                small
                nospace
                onClick={(e) =>
                  m?.options?.length
                    ? setMenuAberto({ indice, ancora: e.currentTarget })
                    : m?.action?.()
                }
                border={m?.border}
                loading={m?.loading}
              >
                {m?.centerIcon ? null : m?.label}
                {m?.centerIcon && <Icon icon={m?.centerIcon} nomargin />}
              </Button>

              {/* Botao com `options` vira dropdown; sem elas, nada muda. */}
              {!m?.options?.length ? null : (
                <Menu
                  anchorEl={menuAberto?.ancora}
                  open={menuAberto?.indice === indice}
                  onClose={() => setMenuAberto(null)}
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                >
                  {m.options.map((opcao, indiceOpcao) => (
                    <MenuItem
                      key={indiceOpcao}
                      disabled={opcao?.disabled}
                      sx={{ gap: '12px', alignItems: 'flex-start' }}
                      onClick={() => {
                        setMenuAberto(null);
                        opcao?.action?.();
                      }}
                    >
                      {!opcao?.icon ? null : (
                        <IconeSimbolo
                          name={opcao.icon}
                          size={20}
                          color="#2670D1"
                        />
                      )}
                      <MenuItemTexto>
                        <MenuItemTitulo>{opcao?.label}</MenuItemTitulo>
                        {!opcao?.description ? null : (
                          <MenuItemDescricao>
                            {opcao.description}
                          </MenuItemDescricao>
                        )}
                      </MenuItemTexto>
                    </MenuItem>
                  ))}
                </Menu>
              )}
            </ButtonContent>
          ))}
        </TableWrapperButtonContainer>
      </TableWrapperHeader>
      {nospace ? null : <FormSpacer />}
      {children}
    </TableWrapperContainer>
  );
}
